import React from "react";

export const Line = () => {
  return (
    <div>
      {" "}
      <div className="c1 center">
        <div
          style={{
            width: "40%",
            height: "0.5px",
            backgroundColor: "#C1C1C1AF",
            borderRadius: "50%",
          }}
        ></div>
      </div>
    </div>
  );
};
